import { TEXT_PROPS } from '@/constants/default-props';

export const INPUT_COMMON_PROPS = {
  isRequired: true,
  ...TEXT_PROPS.body,
  size: 'sm',
  type: 'text',
  variant: 'outline',
  colorScheme: 'blackAlpha',
  backgroundColor: 'bgAlternative',
  color: 'mainColorTextLight',
  borderRadius: '0',
  placeholder: '...',
  textAlign: 'left',
  _placeholder: { color: 'mainColorTextLight' },
  _focus: { borderColor: 'mainColorTextLight' },
};

export const FORM_LABEL_PROPS = {
  ...TEXT_PROPS.body,
  textAlign: 'left',
  color: 'mainColorText',
  margin: '8px 0',
};

export const LOADING_STATE = {
  GET_DATA: 'GET_DATA',
  SUBMIT_DATA: 'SUMIT_DATA',
  IDLE: 'IDLE',
};

export const ALERT = {
  success: false,
  error: false,
  messageTitle: '',
  messageContent: '',
};

export const ERROR_TYPE = {
  name: undefined,
  wish: undefined,
};
